import React from 'react';
import { Navigate } from 'react-router-dom';
import { usersRoutes } from './users/routes';
import { brokerGroupsRoutes } from './brokerGroups/routes';
import { featureFlagsRoutes } from './featureFlags/routes';
import { formFieldConfigsRoutes } from './formFieldConfigs/routes';
import { clientsRoutes } from './clients/routes';
import { claimsRoutes } from './claims/routes';
import { importsRoutes } from './imports/routes';

/**
 * Child routes of /admin, in nav order. /admin itself goes to the users list.
 */
export const adminRoutes = [
	{ index: true, element: <Navigate to='users' replace /> },
	...usersRoutes,
	...brokerGroupsRoutes,
	...featureFlagsRoutes,
	...formFieldConfigsRoutes,
	...clientsRoutes,
	...claimsRoutes,
	...importsRoutes,
];
